export default __webpack_public_path__ + "static/media/1.73c42f1a.jpg";